import { render, staticRenderFns } from "./SDSRcptPayt.vue?vue&type=template&id=02705d99&"
import script from "./SDSRcptPayt.vue?vue&type=script&lang=js&"
export * from "./SDSRcptPayt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports